<script setup lang="ts">
import InputLabel from "@/components/ui/InputLabel.vue";

type Props = {
  modelValue?: string;
  dateTime?: boolean;
  label?: string;
  labelDisabled?: boolean;
};

type Emits = {
  (e: "update:modelValue", value: string): void;
};

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  dateTime: false,
  label: "",
  labelDisabled: false,
});
const emit = defineEmits<Emits>();

function handleInput(event: Event): void {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
}
</script>

<template>
  <div>
    <input-label :text="label" :disabled="labelDisabled" />
    <input
      :value="props.modelValue"
      :type="props.dateTime ? 'datetime-local' : 'date'"
      class="w-full appearance-none rounded-sm border-2 border-kekkle-dark-dark px-3 py-2 text-kekkle-dark shadow-blue-hard-sm outline-hidden focus:ring-3 focus:ring-kekkle-blue dark:bg-kekkle-dark-light dark:text-slate-200"
      @input="handleInput"
    />
  </div>
</template>
